import { DefaultSeoProps } from 'next-seo';

export const defaultSEOConfig: DefaultSeoProps = {
  titleTemplate: '%s',
  defaultTitle: 'SpotOn Order',
  description:
    'Order delicious food online with SpotOn. Fast, easy online ordering for pickup, delivery, and dine-in.',
  canonical: 'https://order.spoton.com',
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: 'https://order.spoton.com',
    site_name: 'SpotOn Order',
    title: 'SpotOn Order',
    description:
      'Order delicious food online with SpotOn. Fast, easy online ordering for pickup, delivery, and dine-in.',
    images: [
      {
        url: 'https://firebasestorage.googleapis.com/v0/b/android-spoton-mobile-192322.appspot.com/o/favicon-32x32.png?alt=media&token=24ab335c-dcba-406f-bc60-7f0115cc381b',
        width: 1200,
        height: 630,
        alt: 'SpotOn Order',
      },
    ],
  },
  additionalMetaTags: [
    {
      name: 'keywords',
      content: 'online ordering, restaurant, delivery, pickup, dine-in, food, SpotOn',
    },
    {
      name: 'author',
      content: 'SpotOn',
    },
    {
      name: 'robots',
      content: 'index, follow',
    },
  ],
  additionalLinkTags: [
    {
      rel: 'icon',
      href: 'https://firebasestorage.googleapis.com/v0/b/android-spoton-mobile-192322.appspot.com/o/favicon-32x32.png?alt=media&token=24ab335c-dcba-406f-bc60-7f0115cc381b',
    },
  ],
};
